module.exports = __webpack_public_path__ + "static/media/icon_service_04_pc.7d8b52a6.webp";